import { ReportTimePeriod } from "./report-time-period";

export default class ReviewerReport {
  constructor(
    private fReviewer: string,
    private fTimePeriod: ReportTimePeriod,
    private fPlushiesCount: number
  ) {
    [fReviewer, fTimePeriod, fPlushiesCount].forEach((arg, index) => {
      if (arg === undefined) {
        throw new Error(`Undefined value passed at position: ${index}`);
      }
    });
  }

  get reviewer(): string {
    return this.fReviewer;
  }

  get timePeriod(): ReportTimePeriod {
    return this.fTimePeriod;
  }

  get plushiesCount(): number {
    return this.fPlushiesCount;
  }
}
